
    import './styles.scoped.css';
    export default {
  "background": "awsui_background_hyvsj_bcw44_93",
  "scrolling-background": "awsui_scrolling-background_hyvsj_bcw44_96",
  "sticky-background": "awsui_sticky-background_hyvsj_bcw44_102",
  "has-sticky-notifications": "awsui_has-sticky-notifications_hyvsj_bcw44_110",
  "breadcrumbs": "awsui_breadcrumbs_hyvsj_bcw44_123",
  "has-sticky-background": "awsui_has-sticky-background_hyvsj_bcw44_133",
  "drawers-container": "awsui_drawers-container_hyvsj_bcw44_145",
  "has-open-drawer": "awsui_has-open-drawer_hyvsj_bcw44_157",
  "disable-body-scroll": "awsui_disable-body-scroll_hyvsj_bcw44_191",
  "drawers-desktop-triggers-container": "awsui_drawers-desktop-triggers-container_hyvsj_bcw44_196",
  "has-multiple-triggers": "awsui_has-multiple-triggers_hyvsj_bcw44_215",
  "drawers-mobile-triggers-container": "awsui_drawers-mobile-triggers-container_hyvsj_bcw44_247",
  "drawers-trigger-content": "awsui_drawers-trigger-content_hyvsj_bcw44_251",
  "drawers-trigger-overflow": "awsui_drawers-trigger-overflow_hyvsj_bcw44_277",
  "drawers-trigger": "awsui_drawers-trigger_hyvsj_bcw44_251",
  "drawer": "awsui_drawer_hyvsj_bcw44_145",
  "drawer-close-button": "awsui_drawer-close-button_hyvsj_bcw44_308",
  "drawer-content": "awsui_drawer-content_hyvsj_bcw44_313",
  "drawer-slider": "awsui_drawer-slider_hyvsj_bcw44_318",
  "is-drawer-open": "awsui_is-drawer-open_hyvsj_bcw44_325",
  "content": "awsui_content_hyvsj_bcw44_350",
  "layout": "awsui_layout_hyvsj_bcw44_371",
  "has-max-content-width": "awsui_has-max-content-width_hyvsj_bcw44_454",
  "content-type-dashboard": "awsui_content-type-dashboard_hyvsj_bcw44_469",
  "is-overlap-disabled": "awsui_is-overlap-disabled_hyvsj_bcw44_486",
  "has-content-gap-left": "awsui_has-content-gap-left_hyvsj_bcw44_518",
  "has-content-gap-right": "awsui_has-content-gap-right_hyvsj_bcw44_521",
  "content-first-child-notifications": "awsui_content-first-child-notifications_hyvsj_bcw44_531",
  "has-breadcrumbs": "awsui_has-breadcrumbs_hyvsj_bcw44_534",
  "content-first-child-header": "awsui_content-first-child-header_hyvsj_bcw44_537",
  "has-header": "awsui_has-header_hyvsj_bcw44_537",
  "content-first-child-main": "awsui_content-first-child-main_hyvsj_bcw44_558",
  "disable-content-paddings": "awsui_disable-content-paddings_hyvsj_bcw44_558",
  "has-split-panel": "awsui_has-split-panel_hyvsj_bcw44_601",
  "split-panel-position-bottom": "awsui_split-panel-position-bottom_hyvsj_bcw44_601",
  "block-body-scroll": "awsui_block-body-scroll_hyvsj_bcw44_617",
  "unfocusable": "awsui_unfocusable_hyvsj_bcw44_622",
  "container": "awsui_container_hyvsj_bcw44_632",
  "is-navigation-open": "awsui_is-navigation-open_hyvsj_bcw44_657",
  "is-tools-open": "awsui_is-tools-open_hyvsj_bcw44_660",
  "is-split-panel-open": "awsui_is-split-panel-open_hyvsj_bcw44_660",
  "split-panel-position-side": "awsui_split-panel-position-side_hyvsj_bcw44_660",
  "mobile-toolbar": "awsui_mobile-toolbar_hyvsj_bcw44_669",
  "mobile-toolbar-nav": "awsui_mobile-toolbar-nav_hyvsj_bcw44_685",
  "mobile-toolbar-breadcrumbs": "awsui_mobile-toolbar-breadcrumbs_hyvsj_bcw44_689",
  "mobile-toolbar-tools": "awsui_mobile-toolbar-tools_hyvsj_bcw44_693",
  "navigation-container": "awsui_navigation-container_hyvsj_bcw44_702",
  "show-navigation": "awsui_show-navigation_hyvsj_bcw44_746",
  "animating": "awsui_animating_hyvsj_bcw44_768",
  "showButtons": "awsui_showButtons_hyvsj_bcw44_1",
  "navigation": "awsui_navigation_hyvsj_bcw44_702",
  "openNavigation": "awsui_openNavigation_hyvsj_bcw44_1",
  "animated-content": "awsui_animated-content_hyvsj_bcw44_830",
  "hide-navigation": "awsui_hide-navigation_hyvsj_bcw44_839",
  "notifications": "awsui_notifications_hyvsj_bcw44_849",
  "sticky-notifications": "awsui_sticky-notifications_hyvsj_bcw44_855",
  "split-panel-bottom": "awsui_split-panel-bottom_hyvsj_bcw44_872",
  "position-bottom": "awsui_position-bottom_hyvsj_bcw44_919",
  "openSplitPanelBottom": "awsui_openSplitPanelBottom_hyvsj_bcw44_1",
  "split-panel-side": "awsui_split-panel-side_hyvsj_bcw44_948",
  "position-side": "awsui_position-side_hyvsj_bcw44_976",
  "openSplitPanelSide": "awsui_openSplitPanelSide_hyvsj_bcw44_1",
  "tools-container": "awsui_tools-container_hyvsj_bcw44_1013",
  "tools": "awsui_tools_hyvsj_bcw44_1013",
  "openTools": "awsui_openTools_hyvsj_bcw44_1",
  "has-tools-form-persistence": "awsui_has-tools-form-persistence_hyvsj_bcw44_1108",
  "hide-tools": "awsui_hide-tools_hyvsj_bcw44_1118",
  "show-tools": "awsui_show-tools_hyvsj_bcw44_1130",
  "has-tools-form": "awsui_has-tools-form_hyvsj_bcw44_1108",
  "trigger": "awsui_trigger_hyvsj_bcw44_1195",
  "selected": "awsui_selected_hyvsj_bcw44_1235",
  "badge": "awsui_badge_hyvsj_bcw44_1245",
  "trigger-wrapper": "awsui_trigger-wrapper_hyvsj_bcw44_1249",
  "dot": "awsui_dot_hyvsj_bcw44_1253"
};
  